import { useEffect, useState } from 'react'
import { indexAssetsBaseLines } from 'api/its/assets_base_lines';
import { indexAssetsTypes } from 'api/its/assets_types';
import { BadgeValue } from 'interfaces/ITableComp';
import { IAssetBaseLine } from 'models/AssetBaseLine';
import { IAssetType } from 'models/AssetsTypes';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

const useInventory = () => {
    const items = useSelector((state: RootState) => state.inventory.its);

    const [theaders, setTheaders] = useState<string[]>([]);
    const [tkeys, setTkeys] = useState<string[]>([]);
    const [values, setValues] = useState<BadgeValue[]>([]);
    const [valuesTypes, setValuesTypes] = useState<BadgeValue[]>([]);
    const [baseLines, setBaseLines] = useState<IAssetBaseLine[]>([]);
    const [assetTypes, setAssetTypes] = useState<IAssetType[]>([]);

    useEffect(() => {
        // Obtener headers y keys de la table del atributo items
        const getTableData = () => {
            setTheaders(items
                .filter((item) => item.table)
                .map((item) => item.label)
                .filter((label): label is string => label !== undefined)
            );
            setTkeys(items.filter((item) => item.table).map((item) => item.key));
        }
        getAssetsBaseLines();
        getAssetsTypes();
        getTableData();
    }, []);
    // Obtener los tipos de elementos de los inventarios
    const getAssetsTypes = async () => {
        const response = await indexAssetsTypes({ package_id: 17, table: "assets_its" });
        if (response.data.length > 0) {
            setAssetTypes(response.data);
            setValuesTypes(
                response.data.map((item) => {
                    const { name, id, color } = item;
                    return { name, value: id, color };
                })
            );
        }
    }
    // Obtener las líneas base de los activos de inventario
    const getAssetsBaseLines = async () => {
        const response = await indexAssetsBaseLines({ package_id: 17 });
        if (response.data.length > 0) {
            setBaseLines(response.data);
            setValues(
                response.data.map((item) => {
                    const { color, name, id } = item;
                    return { name, color, value: id }
                })
            );
        }
    }

    return {
        theaders,
        tkeys,
        values,
        valuesTypes,
        baseLines,
        assetTypes,
    }
}

export default useInventory